interface Price {
    amount: number;
    currency: string;
}

export const getFormattedPrice = (price: Price, locale: string) => {
    try {
        return Intl.NumberFormat(locale, {
            style: 'currency',
            currency: price.currency,
        }).format(price.amount);
    } catch (error) {
        return `${price.amount} ${price.currency}`;
    }
};
